import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA auto-updates
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New version available! App will reload in 2 seconds...');
  },
  onSuccess: (registration) => {
    console.log('Content cached successfully for offline use!');
  }
});